import AiGradientSpinner from '@cobliteam/ui-business/components/AiGradientSpinner';

const AiRecommendationBannerSkeleton = () => (
  <div className='flex w-full items-center gap-4 rounded-2xl border border-[#d9d9e0] border-solid bg-[#fcfdfe] px-5 py-4 shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1)]'>
    <AiGradientSpinner size='sm' />

    <div className='flex flex-col gap-0.5'>
      <span className='font-semibold text-[#0a0a0a] text-sm'>Analisando sua frota com IA</span>
      <span className='text-neutral-400 text-xs'>Isso pode levar alguns segundos...</span>
    </div>
  </div>
);

export default AiRecommendationBannerSkeleton;
